import {
  OrderOptimizerListItem,
  OrderOptimizerListItemOrders,
  OrderOptimizerListItemRoute,
  OrderOptimizerListItemStatus,
} from "../../../../../common/services/order-optimizer/list/order-optimizer-list";
import {
  OrderOptimizerRailyListingItemOrder,
  OrderOptimizerRailyListingItemRoute,
  OrderOptimizerRailyListingItem,
  OrderOptimizerRailyListingItemStatus,
} from "./types/order-optimizer-raily-listing-item";

const createListingItemOrder = (
  order: OrderOptimizerListItemOrders,
): OrderOptimizerRailyListingItemOrder => {
  return {
    cargoCompany: order.cargoCompany,
    humanId: order.humanId,
    startTime: order.startTime,
    taxiCorporation: order.taxiCorporation,
    haltingTimeBefore: order.haltingTimeBefore,
  };
};

const createLIstingItemOrders = (
  orders: OrderOptimizerListItemOrders[],
): OrderOptimizerRailyListingItemOrder[] => {
  return orders.map(createListingItemOrder);
};

const createListingItemRoute = (
  route: OrderOptimizerListItemRoute,
): OrderOptimizerRailyListingItemRoute => {
  return {
    lat: route.lat,
    lon: route.lon,
    orderHumanId: route.orderHumanId,
  };
};

const createLIstingItemRoutes = (
  routes: OrderOptimizerListItemRoute[],
): OrderOptimizerRailyListingItemRoute[] => {
  return routes.map(createListingItemRoute);
};

const createStatus = (
  status: OrderOptimizerListItemStatus,
): OrderOptimizerRailyListingItemStatus => {
  switch (status) {
    case OrderOptimizerListItemStatus.INTERESTING:
      return OrderOptimizerRailyListingItemStatus.INTERESTING;
    case OrderOptimizerListItemStatus.PENDING:
      return OrderOptimizerRailyListingItemStatus.PENDING;
    case OrderOptimizerListItemStatus.REJECTED:
      return OrderOptimizerRailyListingItemStatus.REJECTED;
  }
};

const createListingItem = (
  listItem: OrderOptimizerListItem,
): OrderOptimizerRailyListingItem => {
  return {
    id: listItem.id,
    orders: createLIstingItemOrders(listItem.orders),
    reviewedAt: listItem.reviewedAt,
    reviewedBy: listItem.reviewedBy,
    route: createLIstingItemRoutes(listItem.route),
    score: listItem.score,
    status: createStatus(listItem.status),
  };
};

const createListingItems = (
  listItems: OrderOptimizerListItem[],
): OrderOptimizerRailyListingItem[] => {
  return listItems.map(createListingItem);
};

const orderOptimizerRailyListingItemFactory = {
  createListingItems,
};

export default orderOptimizerRailyListingItemFactory;
